//#region imports
import * as angular from 'angular';
import { fn } from '@common/utils';
import UISafe = fn.UISafe;
import resolveToError = fn.resolveToError;
import { NavClientService } from '../navdata/navdata';
import { NavSettingsService, INavCustomization } from '@common/services/settingsservice';
import { RwfInvoiceDataService } from '../KWFApplication';
import { ExternalFilters } from '../KWFUtils';
import { KWFPreviewService, IPreviewInformationSource, PreviewFieldsType } from '../rwfpreview/KWFPreviewService';
import { IFDRW_Workflow_Setup_WS, IRwfSettings, RwfBootstrap } from '@common/rwf';
import { DialogService } from '@services/dialogservice';
import { MainMenu, ToggleButtonDirective, MainMenuItemDirective, IMainMenuItem } from './menu/mainmenu';
import {
  KWFSearchSettingsService, SearchConfig, KWFSearchCtrl,
  $KWFCurrentSearchSet, $KWFCurrentSearchChanged
} from './search';
import { Bind as kBind, SaveAsExcel } from '../navkendo';
import { CompatibilityService } from '@services/compatibilityservice';
import { Event_ApplyFilter, Event_InvoiceDataRefresh, ID_ProcessErros as ID_ProcessErrors, ID_ProcessPending } from '@common/rwf/rwfinvoicedata';
import { IRwfApplicationSettings } from '@common/rwf/rwf.appsettings';
import '../navkendo/navadapativepanel'; // referenced indirect via html as widget
import { FWFSearchCtrl } from './fwfsearch.ctrl';

//#endregion

// caution: referenced from '../kendo/templates.html' code ...
export function ChooseRowItemSupplementDoc(evt: JQueryEventObject, rowitem?: any, columns?: IPreviewInformationSource, settingPath?: PreviewFieldsType) {
  var previewSvc = KWFPreviewService.GetInstance();
  previewSvc.ChooseRowItemSupplementDoc(evt, rowitem, columns, settingPath);
}

//#region static configuration

//#endregion

//#region KWFMain

/** Interface for the UserDesk controller */
export interface IUserDeskScope extends ng.IScope {
  MainMenu: MainMenu;
  SearchConfigs: SearchConfig[];
  Search: KWFSearchSettingsService;

  /** Information about Current User (from AD/Environment on server) */
  User: {
    /** Display Name for the User */
    DisplayName: string;
    /** (Login) Name of  User */
    UserName: string;
  };
}

/**
 *  Directive/UIController for the User Desk fragment
 * - Allows Access to HTML elements in Context, avoids global JQuery Selectors
 * (If we had done this from the start we might not even have the separation in directive[KWFUserDeskUIController]/KWFUserDeskCtrl or ???)
 */
class KWFUserDeskUIController {

  static $inject = ["$scope", "CompatibilityService"];
  private $c: CompatibilityService;
  constructor($scope: ng.IScope, $c: CompatibilityService, navAccessConfig: INavCustomization | PromiseLike<INavCustomization>) {
    this.$c = $c;
    // Refresh Grid State on position/ size Changes
    let AdaptContentHeightDebounced = $scope["SearchSizeChanged"] = fn.debounce(this._adaptContentHeight.bind(this), 125);

    // Sync Expanded State
    $scope.$watch("MainMenu.Expanded", (isExpanded) => {
      this.mnuExpanded = !!isExpanded;
      this.ToggleMainMenu();
    });

    // TODO :MainMenu logic here ...  move here
    function getMenu() { return <MainMenu>$scope["MainMenu"]; }

    $scope.$on('MainMenuItemChanged', fn.proxy(this.AdaptMainMenuWidth, this, false));

    $scope.$on("kwfUserDesk.allSearchEnd", AdaptContentHeightDebounced);

    // Data grid heigt can only be calculated reliably on visible items.
    // So this needs to be called on each content view change.
    $scope.$watch("MainMenu.SelectedItem", AdaptContentHeightDebounced);

    // Ensure content height on startup and resize
    $(window).resize(AdaptContentHeightDebounced);
    $scope.$on("$destroy", () => $(window).off("resize", AdaptContentHeightDebounced));

    $scope["StartExcelExport"] = (itemId: string, title?: string) => {
      var menuitem = getMenu().MainMenuItems[itemId];
      var kgrid = $("#" + (menuitem && menuitem.ID) + "_content .k-grid:first", this.element).data("kendoGrid");
      if (!kgrid)
        throw new Error("'" + itemId + "' konnte nicht aufgelöst werden!");
      title = title || itemId;
      var exportOptions = [{ Grid: kgrid, Name: title }];
      SaveAsExcel(exportOptions);
    };

  }

  initialize(element) {
    this.element = element;
    this._adaptContentHeight();
    this.AdaptMainMenuWidth(false);
  }

  /** root element context, set in link function of directive */
  private element: JQuery;
  /** Default is true?*/
  private mnuExpanded = true;
  /** TODO PHWO : was too lazy to rewrite all selectors (+ TODO : remove "window") context, + TODO : do not use id's  */
  private $ = $;

  private AdaptMainMenuWidth(animate: boolean) {
    var context = this.element,
      ToggleMainMenu_Time: number = 300,
      jquery = this.$,
      $ = (sel) => jquery(sel, context), // too lazy for full refactoring ....
      expanded = this.mnuExpanded,
      isInitialized = $(".idms_MainMenuItem").length > 0;

    if (isInitialized) {
      let isContentBox = $(document.body).css("box-sizing") === "content-box";

      // Fixed
      var fixedTitleWidth = 103 + 5 + 10;
      var menuItemRightMargin = 10 + (isContentBox ? 0 : 4); // 10px + 4px margin

      /** Current max width of the main menu icon element */
      var menuItemIconWidth = $(".idms_MainMenuItem .idms_MainMenuIcon").GetMaxWidth();
      /** Current max width of the main menu count element */
      var menuItemCountWidth = $(".idms_MainMenuItem .idms_MainMenuItem_Count").GetMaxWidth();
      /** Current main menu item width */
      var menuItemWidth = menuItemIconWidth + (expanded ? fixedTitleWidth : 0) + menuItemCountWidth + (isContentBox ? 0 : menuItemRightMargin); // Math.max.apply(Math, $(".idms_MainMenuItem").map(function () { return $(this).outerWidth(true); }).get());

      // Switch toggle button
      $("#mainMenuToggleOut").css("display", expanded ? "inline" : "none");
      $("#mainMenuToggleIn").css("display", expanded ? "none" : "inline");

      // Animate toggle
      if (animate) {
        $(".idms_MainMenuItem").stop().animate({ width: menuItemWidth + "px" }, ToggleMainMenu_Time);
        $(".idms_MainMenuItem_CountWrapper").stop().animate({ width: menuItemCountWidth + "px" }, ToggleMainMenu_Time);

      } else {
        $(".idms_MainMenuItem").stop().css({ width: menuItemWidth + "px" });
        $(".idms_MainMenuItem_CountWrapper").stop().css({ width: menuItemCountWidth + "px" });
      }

      // Search details
      $(".idms_MainMenuSubGroup").outerWidth((menuItemWidth + 2) + "px");
    }
  }

  /** Expand/collapse the main menu bar */
  private ToggleMainMenu() {
    var jQuery = this.$,
      $ = (sel: string) => jQuery(sel, this.element),
      expanded = this.mnuExpanded == undefined || this.mnuExpanded,
      isInitialized = $(".idms_MainMenuItem").length > 0,
      mnuItemTitle = $(".idms_MainMenuItem_Title");

    if (isInitialized) {
      // Toggle menu item labels
      if (expanded) {
        // Toggle in
        mnuItemTitle.stop().fadeIn();
      } else {
        // Toggle out
        mnuItemTitle.hide();
      }

      // Switch toggle button
      $("#mainMenuToggleOut").css("display", expanded ? "inline" : "none");
      $("#mainMenuToggleIn").css("display", expanded ? "none" : "inline");

      this.AdaptMainMenuWidth(true);
    }
  }

  /** Adapt all grids height to fit in container to avoid double scroll bars */
  private _adaptContentHeight() {
    // TODO: Remove after layout refactor!
    var jquery = this.$,
      context = this.element,
      $ = (selector: string) => jquery(selector, context),
      availHeight = this.element.innerHeight();

    var maxHeight = Math.max(availHeight, 200);

    // MainMenu height
    var mainMenus = $("#idms_MainMenuContainer kwfmainmenuitem");
    var mainMenu = mainMenus.first().find(".idms_MainMenuItem");
    var mainMenuCount = mainMenus.length;
    var mainMenuHeight = mainMenu.outerHeight(true);
    if (!mainMenuHeight) mainMenuHeight = 47; // Fallback (not rendered yet)
    var toggleButtonHeight = context.find("kwftogglebutton").outerHeight(true);
    if (!toggleButtonHeight) toggleButtonHeight = 26; // Fallback (not rendered yet)
    var searchDetailsMaxHeight = Math.max(maxHeight - (25 + mainMenuHeight * mainMenuCount + toggleButtonHeight), 40);
    $(".idms_MainMenuSubGroup").css("max-height", searchDetailsMaxHeight + "px");

    // WTF (US 124557)
    var adaptivePanels = $('*').filter(function () {
      return $(this).data('kendoNavAdaptivePanel') !== undefined;
    }).filter(":visible")
      .toArray()
      .map(item => jquery(item).data('kendoNavAdaptivePanel'));
    adaptivePanels.forEach(adaptivePanel => adaptivePanel.AdaptHeight());
  }

  /** Directive Registration */
  static Directive = [function (): ng.IDirective {
    return {
      controller: KWFUserDeskUIController,
      link: (scope, element, attributes, controller: KWFUserDeskUIController) => {
        // Initialize Element Context of UI Controller
        controller.initialize(element);
      }
    };
  }];
}

/** Main UserDesk controller for NAV/SharePoint */
class KWFUserDeskCtrl {
  static $inject = ["$scope", "CompatibilityService", "$location", "NavSettings", "KWFSearchSettings", "KWFBenutzerSchreibtisch"];
  constructor($scope: IUserDeskScope,
    $c: CompatibilityService,
    $location: ng.ILocationService,
    NavSettings: NavSettingsService,
    KWFSearchSettings: KWFSearchSettingsService,
    KWFBenutzerSchreibtisch: KWFBenutzerSchreibtisch) {
    var isRefresh: boolean = false;
    /** Refresh Current Params State*/
    function RefreshParams(params: { view?, expanded?, filter?: string, search?: string }) {
      if (isRefresh)
        return;
      isRefresh = true;
      try {
        let p = <{ view?, expanded?, filter?, search?}>$location.search();
        if (mainMenu) {
          // Adjust/Reflect current View state
          if (params.view) {
            var sel = mainMenu.SelectItem(params.view);
            if (sel) {
              p.view = sel.ID;
            }
          }
          // Adjust/ Reflect Current Expanded state
          if (params.expanded !== undefined) {
            mainMenu.Expanded = !!params.expanded && !(params.expanded == "0");
          }
          p.expanded = mainMenu.Expanded ? 1 : 0;
        }
        // Ajust Reflect Current Search if view = search
        if (params.search !== undefined) {
          p.search = params.search;
        }

        // Adjust Search
        if (p.view == "search") {
          if (p.search == undefined)
            p.search = (KWFSearchSettings.CurrentSearch && KWFSearchSettings.CurrentSearch.Name) || undefined;
          if (p.search != undefined)
            $scope.$broadcast($KWFCurrentSearchSet, KWFSearchSettings.InitialSearch = p.search);
          else
            delete p.search;
        } else {
          delete p.search;
        }

        if ("filter" in params) {
          p.filter = params.filter;
          if (p.filter) {
            // explicit filter collides with external filters
            ExternalFilters.Reset(p);
          }
        }

        if (!p.filter)
          delete p.filter;
        $location.search(p);
      } finally {
        isRefresh = false;
      }
    }

    // Reset filter in url
    $scope.$on("clearfilter", () => {
      var search = $location.search();
      delete search["filter"];
      ExternalFilters.Reset(search);
      $location.search(search);
    });

    // Refresh Current Search to QueryParameters
    $scope.$on($KWFCurrentSearchChanged, (e, search: SearchConfig) => RefreshParams({ search: (search && search.Name) || "" }));
    // Refresh on Route Change
    $scope.$on("$destroy", <any>$scope.$on("$routeUpdate", (e, route: ng.route.ICurrentRoute) => RefreshParams(route && route.params)));
    var invoiceData = $scope["InvoiceData"] = KWFBenutzerSchreibtisch.InvoiceData;
    var myInvoices = $scope["MyInvoices"] = invoiceData.MyInvoices;
    var allInvoices = $scope["AllInvoices"] = invoiceData.AllInvoices;
    var involvedInvoices = $scope["InvolvedInvoices"] = invoiceData.InvolvedInvoices;
    const FWFItems = $scope["FWFItems"] = invoiceData.FWFItems;
    const FWFAllItems = $scope["FWFAllItems"] = invoiceData.FWFAllItems;
    const ensureFWFItemsVisibility = fn.once(() => $scope["FWFItemsAvailable"] = FWFItems);
    if (FWFItems) {
      const waitForFWF = $scope.$watch(() => FWFItems.TotalCount + FWFAllItems.TotalCount + involvedInvoices.TotalCount, newValue => {
        if (!isNaN(newValue) && (newValue > 0 || (involvedInvoices.Items.filter(item => item.FWFData && item.Involved).length > 0))) {
          waitForFWF();
          ensureFWFItemsVisibility();
        }
      });
    } else {
      ensureFWFItemsVisibility();
    }
    $scope["RefreshInvoiceData"] = invoiceData.ActRefreshInvoiceData;

    // Auto Refresh Visualization if other User Started/Ended Edit ot Item
    $scope.$on("$destroy", invoiceData.ActRefreshInvoiceData.ActivateAutoRefresh());

    // Initial Load Data
    UISafe(invoiceData.ActRefreshInvoiceData.Refresh());
    var mainMenu = $scope.MainMenu = new MainMenu();

    const getDataForSelectedView = () => {
      const selectedId = mainMenu?.SelectedItem?.ID;
      return selectedId == "myinvoice" ? myInvoices :
        (selectedId == "reb" ? allInvoices :
          (selectedId == "inv" ? involvedInvoices :
            (selectedId == "fwf" ? FWFItems :
              (selectedId == "fwfAll" ? FWFAllItems : undefined))));
    };

    [allInvoices, myInvoices, involvedInvoices, FWFItems, FWFAllItems].filter(fn.isSet).map(item => $scope.$on("$destroy", kBind(item, () => {
      if (getDataForSelectedView() !== item) {
        return;
      }

      var fil = fn.FindFirst(item.Filters, "Selected", true);
      RefreshParams({ filter: (fil && fil.ID) || "" });
    }, Event_ApplyFilter)));

    // "Reset Filter on Re - Selectinng alread selected item"
    mainMenu.bind("ResetSelectedItem", () => {
      var selItem = mainMenu.SelectedItem,
        data = selItem == miMyInvoice ? myInvoices : (selItem == miAllInvoice ? allInvoices : (selItem == miInvolvedInvoice ? involvedInvoices :
                    (selItem == miFwfItems ? FWFItems :  (selItem == miAllFwfItems ? FWFAllItems : undefined))));

      if (data)
        data.ApplyFilter("");
    });
    mainMenu.bind("ItemSelected", (e) => RefreshParams({ view: e && e.Item && e.Item.ID }));
    $scope.$on("$destroy", () => mainMenu.unbind(undefined));
    mainMenu.Expanded = true;

    // Get user
    const appSettings = KWFBenutzerSchreibtisch.ApplicationSettings;
    const user = $scope.User = appSettings && appSettings.User;

    if (user.IsStandalone !== true) {
      mainMenu.AddItem("search");
    }

    const miMyInvoice = mainMenu.AddItem("myinvoice"),
      myProcessErrors = fn.FindFirst(involvedInvoices.Filters, "ID", ID_ProcessErrors),
      myProcessPending = fn.FindFirst(involvedInvoices.Filters, "ID", ID_ProcessPending),
            myinvWarning = myProcessErrors && { Warning: { Message: '' , IsError: false } },
      miInvolvedInvoice = mainMenu.AddItem("inv", myinvWarning),
      miFwfItems = mainMenu.AddItem('fwf'),
      miAllFwfItems = mainMenu.AddItem('fwfAll'),
      miAllInvoice = mainMenu.AddItem("reb");

    $c.resolve("Rwf")("RwfBootstrap").OnResolved(a => {
            if(a.RwfUser.IsFWFSearchAllowed !== false) {
        mainMenu.AddItem('fwfsearch');
      }
    }, true);
    if (myProcessErrors && myProcessPending) {
      const refresh = () => {
        const w = myinvWarning.Warning;
        const CountErrors = involvedInvoices.FilterCount[ID_ProcessErrors];
        const CountPending = involvedInvoices.FilterCount[ID_ProcessPending];
        if (!(CountErrors + CountPending > 0)) {
          w.Message = '';
          w.IsError = false;
          return;
        } else if (CountErrors > 0) {
          w.Message = 'Es gibt Probleme bei von Ihnen weitergeleiteten Belegen!';
          w.IsError = true;
        } else {
          w.Message = 'Belege warten auf Weiterleitung';
          w.IsError = false;
        }
      };
      $scope.$on("$destroy", kBind(involvedInvoices, refresh, Event_InvoiceDataRefresh));
      refresh();
    }
    // Get url params
    var urlparams = $location.search();

    // Check for view param
    var forcedView = urlparams['view'];
    var forcedexpanded = urlparams['expanded'];

    var initFilter = urlparams['filter'] || "";
    const applyKnownFilter = (data: { Filters: { ID: string }[]; ApplyFilter: (item: string) => any }, filterId: string) => {
      if (!data) {
        return;
      }

      if (!filterId) {
        data.ApplyFilter("");
        return;
      }

      // Guard against stale/foreign URL filter ids (e.g. from other lists or old installs).
      const hasFilter = !!fn.FindFirst(data.Filters, "ID", filterId);
      data.ApplyFilter(hasFilter ? filterId : "");
    };

    if (forcedView == "fwf" && initFilter && FWFItems) {
      ensureFWFItemsVisibility();
      // Problem : fwf filter is available only after Data is loaded
      $c.when(FWFItems.Items?.length > 0 ? undefined : FWFItems.GetData())
        .then(() => FWFItems.ApplyFilter(initFilter));
    } else if (forcedView == "fwfAll" && initFilter && FWFAllItems) {
      ensureFWFItemsVisibility();
      // Problem : fwf filter is available only after Data is loaded
      $c.when(FWFAllItems.Items?.length > 0 ? undefined : FWFAllItems.GetData())
        .then(() => FWFAllItems.ApplyFilter(initFilter));
    } else {
      const startupView = forcedView || "myinvoice";
      if (startupView == "reb") {
        applyKnownFilter(allInvoices, initFilter);
      } else if (startupView == "inv") {
        applyKnownFilter(involvedInvoices, initFilter);
      } else {
        applyKnownFilter(myInvoices, initFilter);
      }
    }

    // Load Search Settings
    KWFSearchSettings.GetUserSearchSettings().then(searchConfigItems => {
      $scope.SearchConfigs = searchConfigItems;
      $scope.Search = KWFSearchSettings;
    }).then(undefined, err => {
      // tslint:disable-next-line:ban
      alert("Das Laden der Suchkonfigurationen ist fehlgeschlagen!");
    });

    // Init Drag & Drop Options
    $scope["searchSortableOptions"] = <kendo.ui.SortableOptions>{
      end: (e: kendo.ui.SortableEndEvent) => {
        e.preventDefault();
        var searchConfigs = $scope.SearchConfigs,
          itemMoved = searchConfigs[e.oldIndex];
        searchConfigs.splice(e.oldIndex, 1);
        searchConfigs.splice(e.newIndex, 0, itemMoved);
        // Save in New Order
        $(e.sender.element).kendoNavBusyIndicator(KWFSearchSettings.SetItems(searchConfigs).then(reloaded => {
          $scope.SearchConfigs = reloaded;
        }));
      }
    };
    // Watch
    $scope.$watch(() => mainMenu.Expanded, (newValue, oldValue) => {
      RefreshParams({});
    });

    // SetUp User Settings Persistence
    var userSettings = NavSettings.CreateUserSettings(["KWF", "KWFuserDekCtrl"]);
    userSettings.Add("UserDesk", () => {
      return {
        MenuExpanded: mainMenu.Expanded,
        Selected: mainMenu.SelectedID
      };
    }, state => {
      if (forcedexpanded == undefined)
        forcedexpanded = state.MenuExpanded !== false; // Only Change if setting available
      forcedView = forcedView || state.Selected; // forced View From URL precedes view from usersettings
    });

    const afterLoad = () => {
      // Select Item after Load
      RefreshParams({
        view: forcedView || 'myinvoice',
        expanded: forcedexpanded
      });
    };
    userSettings.Load().then(afterLoad, afterLoad);

    $scope.$on("$destroy", () => {
      userSettings.Save();
      mainMenu = $scope.MainMenu = null;
    });

    $scope.$on('RWF:CacheCleared', () => {
      if ($scope["RefreshInvoiceData"] && $scope["RefreshInvoiceData"].Refresh) {
        $scope["RefreshInvoiceData"].Refresh();
      }
    });
  }
}

//#endregion

/** 'Benutzerschreibtisch App' Anchor; not nice (way too much coupling) but easy for now use with caution... */
export class KWFBenutzerSchreibtisch {
  static $inject = ["CompatibilityService", "DialogService", "RwfBootstrap", "NavClient"];
  constructor(
    public $c: CompatibilityService,
    public DialogService: DialogService,
    public readonly RwfBootstrap: RwfBootstrap,
    public NavClient: NavClientService
  ) {
    const $rwf = $c.resolve("Rwf"),
      loadSettings = RwfBootstrap.Resolve.then(() => $c.all({
        Bootstrap: RwfBootstrap.Resolve,
        Config: $rwf("RwfAppSettings").Get(),
        SearchPages: $rwf("RwfAppSettings").EffectiveSearchPages,
        InvoiceData: $rwf("RwfInvoiceData").Resolve
      })).then(settings => {
        const Bootstrap = settings.Bootstrap;
        this.ApplicationSettings = Bootstrap.RwfSettings;
        this.WfSetup = Bootstrap.RwfSetup;
        this.Settings = settings.Config;
        this.InvoiceData = settings.InvoiceData;
        this.InvoiceData.RefreshInvoiceData();
        return settings;
      });
    var loadConfig = loadSettings.then(config => {
      const searchPages = config.SearchPages;
      const navUrl = this.ApplicationSettings.NavUrl;
      var pageNames = Object.getOwnPropertyNames(searchPages).map(name => searchPages[name]).filter(item => !item.Disabled).map(item => item.NavPageName);
      if (navUrl && config.Bootstrap.RwfSettings.User.IsStandalone !== true)
        return NavClient.EnsurePageMetaData(pageNames, navUrl).then(fn.noop, err => {
          console.error(resolveToError(err, false));
        });
    });
    // Ensure Resolved here to force correct initialization of data
    this.Resolve = $c.all([loadConfig, loadSettings]).then(fn.ToFunc(this));
  }

  public Resolve: PromiseLike<KWFBenutzerSchreibtisch>;

  public InvoiceData: RwfInvoiceDataService;

  public Settings: IRwfApplicationSettings;

  public ApplicationSettings: IRwfSettings;

  public WfSetup: IFDRW_Workflow_Setup_WS;
}

angular.module("BenutzerSchreibtisch", ["infoma.navkendo", "kendo.directives", "ui.bootstrap"])
  .service("KWFBenutzerSchreibtisch", KWFBenutzerSchreibtisch)
  .controller("KWFSearchCtrl", KWFSearchCtrl)
  .directive("rwfUserdeskSearch", KWFSearchCtrl.Directive)
  .directive("fwfSearch", FWFSearchCtrl.Directive)
  .controller("KWFUserDeskCtrl", KWFUserDeskCtrl)
  .directive("kwfuserdeskdirective", KWFUserDeskUIController.Directive)
  .service("KWFSearchSettings", KWFSearchSettingsService)
  .directive("kwftogglebutton", ToggleButtonDirective)
  .directive("kwfmainmenuitem", MainMenuItemDirective)
  ;
